export default __webpack_public_path__ + "static/media/SD-paroksha-seva-tv-bg.0d7bea1e.png";